import { EmailAccountService } from "./email-account.service";
import { EmailAccountDelegate } from "./email-account.delegate";
import { HttpProviderFactory } from "../http/http-provider.factory";
import { SpinnerService } from "../SpinnerService/spinner.service";
import { IAppConfig } from "../http/types/IApplicationConfig";

export class EmailAccountServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService): EmailAccountService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new EmailAccountDelegate(config, httpProvider);
        return new EmailAccountService(delegate);
    }
}
